import React from 'react';
import './styles/custom-error-box.css';
import ICustomErrorBoxProps from './interfaces/i-custom-error-box-props';

const CustomErrorBox = (props: ICustomErrorBoxProps) => {
    const showTruncated = props.messages.length > 2;
    const visibleMessages = showTruncated ? props.messages.slice(0, 2) : props.messages;

    return (
        <div className="error-box">
            <i aria-hidden="true" className="fa fa-exclamation-triangle" />
            <ul className="errors-list">
                {visibleMessages.map((item, i) => {
                    const isLast = i === visibleMessages.length - 1;
                    const shouldTruncate = showTruncated && isLast;
                    return (
                        <li key={i}>
                            {shouldTruncate ? `${item.slice(0, 20)}...` : item}
                        </li>
                    );
                })}
            </ul>
            {showTruncated && (
                <a href="#" className="view-all" onClick={props.onViewAllMessages}>View All</a>
            )}
            <i aria-hidden="true" className="fa fa-times" onClick={props.onClose} />
        </div>
    );
};

export default CustomErrorBox;
